export const ADO_BUILD_VERSION = '20250625.1';
